import { render, staticRenderFns } from "./Setor.vue?vue&type=template&id=4d024e3c&scoped=true"
import script from "./Setor.vue?vue&type=script&lang=js"
export * from "./Setor.vue?vue&type=script&lang=js"
import style0 from "./Setor.vue?vue&type=style&index=0&id=4d024e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d024e3c",
  null
  
)

export default component.exports